import { render, staticRenderFns } from "./LoadSap.vue?vue&type=template&id=65bc9aaa"
import script from "./LoadSap.vue?vue&type=script&lang=js"
export * from "./LoadSap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports